import request from '@/utils/request'

export function updateDailyRewardCfg(data) {
  return request({
    url: 'api/v1/daily-reward/updateCfg',
    method: 'post',
    data: data
  })
}

export function getDailyRewardCfgList(data) {
  return request({
    url: 'api/v1/daily-reward/getList',
    method: 'post',
    data: data
  })
}

export function importRewardCfg(data) {
  return request({
    url: 'api/v1/daily-reward/importCfg',
    method: 'post',
    data: data
  })
}

export function getFirstCfg(data) {
  return request({
    url: 'api/v1/daily-reward/getFirst',
    method: 'post',
    data: data
  })
}

export function delFirstCfg(data) {
  return request({
    url: 'api/v1/daily-reward/delFirst',
    method: 'delete',
    data: data
  })
}

